<style lang="less" scoped>
.main {
  background-color: @white;
  border-radius: @border-radius-base;
  width: 1240px;
  margin: 0 auto;
  padding: 30px;
  margin-top: 30px;
  margin-bottom: 30px;
  position: relative;
  .load {
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(50%, 50%);
    z-index: 99;
  }
  .upLoad {
    display: flex;
    position: absolute;
    right: 10px;
    top: 20px;
    z-index: 9;
    .textLeft {
      width: 100px;
      height: 30px;
      line-height: 30px;
      margin-top: 20px;
      color: #040506;
      font-size: 20px;
      letter-spacing: 5px;
    }
    .imgSize {
      width: 80px;
      height: 80px;
      border-radius: 50%;
    }
    .ant-upload-text {
      width: 140px;
      height: 44px;
      line-height: 44px;
      background-image: linear-gradient(122deg, #ff8d46 0%, #fa5542 100%);
      border-radius: 8px;
      margin: -7px 0 0 10px;
      .uploadText {
        color: #fff;
        font-size: 16px;
      }
    }
  }
  .imgTop {
    width: 244px;
    height: 157px;
    .video {
      width: 244px;
      height: 157px;
    }
    img {
      width: 244px;
      height: 157px;
    }
  }
  .imgBot {
    display: flex;
    margin-top: 10px;
    .imgName {
      flex: 22;
      color: #9d9292;
      font-size: 16px;
    }
    .imgDel {
      color: #db5647;
      flex: 2;
      text-align: right;
      font-size: 16px;
      cursor: pointer;
    }
  }
  .tabList {
    .upload {
      display: inline-block;
      width: 50%;
      color: #a3af90;
      &:hover {
        cursor: pointer;
      }
    }
    .del {
      display: inline-block;
      width: 50%;
      color: #db5647;
      &:hover {
        cursor: pointer;
      }
    }
  }
  .bgcTypeImg {
  width: 60px;
  height: 50px;
}
.row {
  width: 100%;
  .col {
    height: 50px;
    line-height: 50px;
  }
}
/deep/.ant-list-vertical .ant-list-item {
  width: 100%;
}
/deep/.ant-list-pagination {
  text-align: center;
}
/deep/.ant-spin-container {
  min-height: 450px;
}
/deep/.ant-upload.ant-upload-select-picture-card {
  border: none;
  background: #fff;
  height: 30px;
}
}

</style>

<template>
  <div class="main">
    <a-spin class="load"
            v-show="loading" />
    <div class="upLoad">
      <a-upload name="avatar"
                list-type="picture-card"
                class="avatar-uploader"
                :show-upload-list="false"
                action=""
                :before-upload="beforeUpload1"
                @change="handleChange"
                v-show="uploadPhoto">
        <div>
          <div class="ant-upload-text">
            <span class="uploadText">{{uploadText}}</span>
          </div>
        </div>
      </a-upload>
      <a-upload name="avatar"
                list-type="picture-card"
                class="avatar-uploader"
                :show-upload-list="false"
                action=""
                :before-upload="beforeUpload2"
                @change="handleChange"
                v-show="uploadVideo">
        <div>
          <div class="ant-upload-text">
            <span class="uploadText">{{uploadText}}</span>
          </div>
        </div>
      </a-upload>
      <a-upload name="avatar"
                list-type="picture-card"
                class="avatar-uploader"
                :show-upload-list="false"
                action=""
                :before-upload="beforeUpload3"
                @change="handleChange"
                v-show="uploadExcel">
        <div>
          <div class="ant-upload-text">
            <span class="uploadText">{{uploadText}}</span>
          </div>
        </div>
      </a-upload>
    </div>
    <div class="tabList">
      <a-tabs default-active-key="1"
              @change="tabList">
        <a-tab-pane key="1"
                    tab="图片">
          <a-list item-layout="vertical"
                  :grid="{ gutter: 16, column: 4 }"
                  size="large"
                  :pagination="pagination"
                  :data-source="dataList">
            <a-list-item slot="renderItem"
                         key="item.title"
                         slot-scope="item">
              <template>
                <div class="imgTop">
                  <img slot="extra"
                       :src="resBasePath+'/'+item.filePath"
                       alt="" />
                </div>
                <div class="imgBot">
                  <span class="imgName">{{item.fileName}}</span>
                  <span class="imgDel"
                        @click="delPhoto(item.id)">
                    <a-icon type="delete" />
                  </span>
                </div>
              </template>
            </a-list-item>
          </a-list>
        </a-tab-pane>
        <a-tab-pane key="2"
                    tab="视频"
                    force-render>
          <a-list item-layout="vertical"
                  :grid="{ gutter: 24, column: 3 }"
                  size="large"
                  :pagination="pagination"
                  :data-source="dataList">
            <a-list-item slot="renderItem"
                         key="item.title"
                         slot-scope="item">
              <template>
                <div class="imgTop">
                  <video class="video"
                         :src="resBaseVideo+'/'+item.filePath"
                         controls="controls"
                         poster=""></video>
                </div>
                <div class="imgBot">
                  <span class="imgName">{{item.name}}</span>
                  <span @click="delVideo(item.id)"
                        class="imgDel">
                    <a-icon type="delete" />
                  </span>
                </div>
              </template>
            </a-list-item>
          </a-list>
        </a-tab-pane>
        <a-tab-pane key="3"
                    tab="教案">
          <a-list item-layout="horizontal"
                  :pagination="pagination"
                  :data-source="dataList">
            <a-list-item slot="renderItem" slot-scope="item">
              <!-- <a-list-item-meta> -->
              <a-row class="row">
                <a-col :span="3"
                      class="col">
                  <img v-if="item.filePath.split('.')[1]=='ppt'||item.filePath.split('.')[1]=='pptx'||item.filePath.split('.')[1]=='pdf'"
                            class="bgcTypeImg"
                            src="../../../assets/image/33.png"
                            alt="">
                  <img v-if="item.filePath.split('.')[1]=='doc'||item.filePath.split('.')[1]=='docx'"
                        class="bgcTypeImg"
                        src="../../../assets/image/34.png"
                        alt="">
                </a-col>
                <a-col :span="18"
                       class="col">{{item.fileName}}</a-col>
                <a-col :span="3"
                       class="col">
                  <a class="upload" :href="resBasePath+'/'+item.filePath">下载</a>
                  <span class="del"
                        @click="delDoc(item.id)">删除</span>
                </a-col>
              </a-row>
              <!-- </a-list-item-meta> -->
            </a-list-item>
          </a-list>
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import tsVideo from '../components/tsvideo.vue'
// var type
export default {
  name: 'Resources',
  data () {
    return {
      loading: true,
      resBasePath: this.$resBasePath,
      resBaseVideo: this.$resBaseVideo,
      uploadText: '上传图片',
      uploadPhoto: true,
      uploadVideo: false,
      uploadExcel: false,
      type: '1',// 1图片2视频3文档
      listData: [],
      dataList: [],
      pagination: {
        onChange: page => {
          //console.log(page)
        }
        // pageSize: 4,
      },
      filePath: '', // 图片路径
      fileName: '', // 图片名
      token: ''
    }
  },
  mounted () {
    this.token = localStorage.getItem('access_token')
    this.getList()
  },
  methods: {
    tabList (key) {
      //console.log(key)
      switch (key) {
        case '1':
          this.uploadText = '上传图片'
          this.uploadPhoto = true
          this.uploadVideo = false
          this.uploadExcel = false
          this.type = 1
          this.getList()
          break
        case '2':
          this.uploadText = '上传视频'
          this.uploadPhoto = false
          this.uploadVideo = true
          this.uploadExcel = false
          this.type = 2
          this.getList()
          break
        case '3':
          this.uploadText = '上传文案'
          this.uploadPhoto = false
          this.uploadVideo = false
          this.uploadExcel = true
          this.type = 3
          this.getList()
          break
      }
    },
    getList () {
      this.loading = true
      const param = {
        teacherId: this.$getUserInfo().id,
        type: this.type,
        styleId: localStorage.getItem('styleId')
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/base/getTeacherResourceBase',
        body: param
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        //console.log(res)
        this.dataList = res.resultData
        this.loading = false
      })
    },
    delPhoto (id) {
      const param = { id: id }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/base/deleteBaseResource',
        body: param
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        this.$message.success('删除成功')
        this.getList()
      })
    },
    delVideo (id) {
      const param = { id: id }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/base/deleteBaseResource',
        body: param
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        this.$message.success('删除成功')
        this.getList()
      })
    },
    delDoc (id) {
      const param = { id: id }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/base/deleteBaseResource',
        body: param
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        this.$message.success('删除成功')
        this.getList()
      })
    },
    beforeUpload1 (file) {//图片
      this.laoding = true
      const formData = new FormData()
      formData.append('file', file)
      formData.append("customDir","hytc_ebook_server/file")
      formData.append('access_token', this.token || '')
      // 上传图片方法
      const _this = this
      axios({
        url: _this.$uploadUrl,
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(res => {
        if (res && res.status === 200) {
          //console.log(type)
          const param = {
            teacherId: this.$getUserInfo().id,
            type: '1',
            filePath: res.data.url,
            fileName: ''
          }
          _this.$fetch({
            url: _this.$baseUrl + 'ebook/teacher/base/saveBaseResource',
            body: param
          }).loading(
            () => (_this.loading = true),
            () => (_this.loading = false)
          ).done(res => {
            _this.$message.success('上传成功')
            _this.getList()
          })
        }
      })
    },
    beforeUpload2 (file) {//视频
      this.laoding = true
      const formData = new FormData()
      formData.append('file', file)
      formData.append("customDir","hytc_ebook_server/file")
      formData.append('access_token', this.token || '')
      // 上传图片方法
      const _this = this
      axios({
        url: _this.$uploadUrl,
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(res => {
        if (res && res.status === 200) {
          //console.log(type)
          const param = {
            teacherId: this.$getUserInfo().id,
            type: '2',
            filePath: res.data.url,
            fileName: ''
          }
          _this.$fetch({
            url: _this.$baseUrl + 'ebook/teacher/base/saveBaseResource',
            body: param
          }).loading(
            () => (_this.loading = true),
            () => (_this.loading = false)
          ).done(res => {
            _this.$message.success('上传成功')
            _this.getList()
          })
        }
      })
    },
    beforeUpload3 (file) {//3文档
      this.laoding = true
      const formData = new FormData()
      formData.append('file', file)
      formData.append("customDir","hytc_ebook_server/file")
      formData.append('access_token', this.token || '')
      // 上传图片方法
      const _this = this
      axios({
        url: _this.$uploadUrl,
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(res => {
        if (res && res.status === 200) {
          //console.log(type)
          const param = {
            teacherId: _this.$getUserInfo().id,
            type: '3',
            filePath: res.data.url,
            fileName: ''
          }
          _this.$fetch({
            url: _this.$baseUrl + 'ebook/teacher/base/saveBaseResource',
            body: param
          }).loading(
            () => (_this.loading = true),
            () => (_this.loading = false)
          ).done(res => {
            _this.$message.success('上传成功')
            _this.getList()
          })
        }
      })
    },
    handleChange (info) {
      if (info.file.status === 'uploading') {
        this.loading = true
        return
      }
      if (info.file.status === 'done') {
        // Get this url from response in real world.
        getBase64(info.file.originFileObj, imageUrl => {
          this.imageUrl = imageUrl
          this.loading = false
        })
      }
    }
  },
  components: {
    tsVideo
  }
}
</script>
